import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';
import {FormDefinitionFormSummaryModel} from './formDefinitionFormSummary.model';

export abstract class SummaryWithFormDefinitionSummaryModel extends WithPermissionModel{
    formDefinition: FormDefinitionFormSummaryModel;
}
